import { createActions, createReducer } from 'reduxsauce'

import FuncoesService from '../servicos/FuncaoDespesaService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaFuncaoInicio: [],
    buscaFuncaoSucesso: ['funcao'],
    buscaFuncaoErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaFuncoes = exercicio => {
    return dispatch => {
        dispatch(Creators.buscaFuncaoInicio())
        let serv = new FuncoesService()
        return serv
            .getFuncoes(exercicio)
            .then(response => dispatch(Creators.buscaFuncaoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaFuncaoErro(error)))
    }
}

const buscaFuncaoInicio = (state = INITIAL_STATE, action) => {
    return { ...state, carregando: true, erro: null }
}

const buscaFuncaoErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaFuncaoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.funcao, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_FUNCAO_INICIO]: buscaFuncaoInicio,
    [Types.BUSCA_FUNCAO_ERRO]: buscaFuncaoErro,
    [Types.BUSCA_FUNCAO_SUCESSO]: buscaFuncaoSucesso,
})
